import {
  Box,
  Grid,
  IconButton,
  InputBase,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Button,
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import createInstance from "../../../api/axiosinstance";
import React, { useEffect, useState } from "react";

import moment from "moment";
import { toast } from "react-toastify";

const CompletedInterviews = () => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchTerm, setSearchTerm] = useState("");
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedInterviewId, setSelectedInterviewId] = useState(null);
  const organizationId = window.sessionStorage.getItem("organizationId");
  console.log("ORGID" + organizationId);
  const aiDishaApi = createInstance("DISHA");

  const fetchInterviews = async () => {
    console.log("Fetching completed interviews for org:", organizationId);
    try {
      const response = await aiDishaApi.get(`/completed_interviews`, {
        params: { organization_id: organizationId }, // Query parameters
      });
  
      console.log("Fetched completed interviews:", response.data);
  
      if (Array.isArray(response.data)) {
        setData(response.data);
      } else {
        console.error("Unexpected response structure:", response.data);
        setData([]); // Reset to an empty array if data format is incorrect
      }
    } catch (error) {
      console.error("Error fetching interview data:", error);
      toast.error(
        `Error fetching interviews: ${error.response?.data?.message || error.message}`
      );
    }
  };
  

  useEffect(() => {
    fetchInterviews();
  }, []);

  const tableHeaders = [
    {
      id: "Candidate ID",
      name: "Candidate Name",
      position: "Job Title",
      date: "Interview Date",
      interviewer: "Interviewer",
      status: "Status",
      action: "Action",
    },
  ];

  const filteredData = data.filter((item) =>
    Object.values(item).some(
      (value) =>
        value &&
        value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleViewModalOpen = (interviewId) => {
    setSelectedInterviewId(interviewId);
    setIsViewModalOpen(true);
  };

  const handleViewModalClose = () => {
    setIsViewModalOpen(false);
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    setPage(1);
  };

  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const formatDate = (dateString) => {
    return moment(dateString).format("DD/MM/YYYY");
  };

  return (
    <div>
      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        sx={{
          marginTop: "auto",
          alignItems: "center",
          borderRadius: "10px",
          padding: "1% 1%",
        }}
      >
        <Box
          gridColumn="span 12"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "1%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", fontSize: "31px", color: "#033538" }}
          >
            Completed Interviews
          </Typography>
        </Box>

        <Box
          gridColumn="span 12"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Paper
            sx={{
              p: "2px 4px",
              display: "flex",
              width: "65%",
              borderRadius: 2,
              border: "1px solid #A7A7A7",
              bgcolor: "#033538",
            }}
          >
            <IconButton type="button" sx={{ p: "8px" }} aria-label="search">
              <SearchIcon />
            </IconButton>
            <InputBase
              sx={{ ml: 1, flex: 1, fontFamily: "poppins" }}
              placeholder="Search by Name, Email or Mobile number"
              inputProps={{ "aria-label": "search google maps" }}
              value={searchTerm}
              onChange={handleSearch}
            />
          </Paper>
        </Box>
      </Box>
      <Box xs={1} sx={{ backgroundColor: "#33333" }}>
        <Grid container spacing={1} sx={{ justifyContent: "center" }}>
          <Grid item xs={10}>
            <TableContainer sx={{ mt: "25px", borderRadius: "10px" }}>
              <Table>
                <TableHead sx={{ backgroundColor: "#033538" }}>
                  {tableHeaders.map((tableHeader) => (
                    <TableRow key={tableHeader.id}>
                      <TableCell
                        sx={{
                          color: "white",
                          borderBottom: 0,
                          borderLeft: "1px solid black",
                        }}
                      >
                        {tableHeader.id}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {tableHeader.name}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {tableHeader.position}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {tableHeader.date}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {tableHeader.interviewer}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {tableHeader.status}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableHead>
                <TableBody>
                  {paginatedData.map((n) => (
                    <TableRow
                      key={n.interview_id}
                      sx={{ backgroundColor: "#006A71", marginRight: "30px" }}
                    >
                      <TableCell
                        sx={{ color: "white", border: "1px solid black" }}
                      >
                        {n.candidate_id}
                      </TableCell>
                      <TableCell
                        sx={{ color: "white", border: "1px solid black" }}
                      >
                        {n.candidate_name}
                      </TableCell>
                      <TableCell
                        sx={{ color: "white", border: "1px solid black" }}
                      >
                        {n.job_title}
                      </TableCell>
                      <TableCell
                        sx={{ color: "white", border: "1px solid black" }}
                      >
                        {formatDate(n.date_and_time)}
                      </TableCell>
                      <TableCell
                        sx={{ color: "white", border: "1px solid black" }}
                      >
                        {n.interviewer_name}
                      </TableCell>
                      <TableCell
                        sx={{ color: "white", border: "1px solid black" }}
                      >
                        {n.Status}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={filteredData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                  backgroundColor: "#033538",
                  color: "white",
                }}
              />
            </TableContainer>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default CompletedInterviews;
